import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Logger } from '../logger.service';

import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthenticationGuard {
  constructor(private router: Router, private authService: AuthenticationService) {}

  canActivate() {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }

  canActivateChild() {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }
}
